var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#786DBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9612 6.05876L8.04489 5.1402C7.92151 5.02219 7.85006 4.86001 7.84627 4.68933C7.84247 4.51865 7.90663 4.35345 8.02464 4.23007C8.14264 4.1067 8.30482 4.03525 8.4755 4.03146C8.64619 4.02766 8.81139 4.09182 8.93476 4.20982L8.95614 4.2312L11.0014 6.27645C11.2528 6.52789 11.2528 6.93457 11.0014 7.18601L8.95389 9.23126C8.8324 9.34716 8.6704 9.41095 8.50251 9.40897C8.33462 9.407 8.17416 9.33943 8.05544 9.22071C7.93672 9.10198 7.86914 8.94152 7.86717 8.77363C7.8652 8.60574 7.92898 8.44374 8.04489 8.32226L9.00507 7.36207C8.35816 7.24788 7.69178 7.33534 7.09624 7.61258C6.5007 7.88982 6.00479 8.34345 5.67571 8.912C5.34663 9.48054 5.2003 10.1365 5.25655 10.791C5.31279 11.4455 5.56889 12.0669 5.99014 12.571C6.41139 13.075 6.97742 13.4374 7.61153 13.609C8.24564 13.7806 8.91717 13.753 9.53511 13.5302C10.1531 13.3073 10.6875 12.8998 11.0661 12.363C11.4447 11.8261 11.6491 11.1859 11.6516 10.5289V3.45495C11.6516 3.28443 11.7194 3.1209 11.8399 3.00032C11.9605 2.87975 12.1241 2.81201 12.2946 2.81201C12.4651 2.81201 12.6286 2.87975 12.7492 3.00032C12.8698 3.1209 12.9375 3.28443 12.9375 3.45495V10.615C12.9196 11.5234 12.6271 12.405 12.0985 13.144C11.57 13.8829 10.8302 14.4446 9.97636 14.7551C9.12254 15.0656 8.19473 15.1104 7.31497 14.8836C6.43521 14.6568 5.64471 14.169 5.04744 13.4844C4.45018 12.7998 4.07413 11.9504 3.96876 11.048C3.86339 10.1456 4.03363 9.23246 4.45709 8.42866C4.88056 7.62486 5.53741 6.96805 6.34124 6.54465C7.14508 6.12125 8.05825 5.95107 8.96064 6.05651L8.9612 6.05876Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDock);
export default __webpack_public_path__ + "static/media/dock.12e41e6ca446600484d4f25bab7ae8e6.svg";
export { ForwardRef as ReactComponent };